import { Controller } from '@hotwired/stimulus'
import { policyFor, stateFor } from '../lib/category_fields.mjs'

export default class extends Controller {
  static values = { configuration: Object }
  static targets = ['category', 'field', 'input', 'optional', 'required', 'preference', 'preferenceContainer']

  connect() {
    this.applyPolicies()
  }

  categoryChanged() {
    this.applyPolicies()
    this.notifyForm()
  }

  preferenceChanged(event) {
    const preference = event.currentTarget
    const input = this.inputFor(preference.dataset.fieldName)

    if (preference.checked) {
      input.dataset.specificValue = input.value
      input.value = ''
    } else if (!input.value && input.dataset.specificValue) {
      input.value = input.dataset.specificValue
    }

    this.applyPolicies()
    this.notifyForm()
  }

  applyPolicies() {
    const category = this.categoryTarget.value

    this.fieldTargets.forEach((fieldContainer) => {
      const fieldName = fieldContainer.dataset.fieldName
      const input = this.inputFor(fieldName)
      const preference = this.preferenceFor(fieldName)
      const policy = policyFor(this.configurationValue, category, fieldName)
      const state = stateFor(policy, preference?.checked)

      fieldContainer.hidden = state.hidden
      input.required = state.required
      input.disabled = state.disabled
      input.setAttribute('aria-required', state.required ? 'true' : 'false')

      this.markerFor(this.optionalTargets, fieldName).hidden = !state.optionalVisible
      this.markerFor(this.requiredTargets, fieldName).hidden = !state.required

      const preferenceContainer = this.markerFor(this.preferenceContainerTargets, fieldName)
      if (preferenceContainer) preferenceContainer.hidden = !state.preferenceVisible
      if (preference) preference.disabled = !state.preferenceVisible
    })
  }

  inputFor(fieldName) {
    return this.inputTargets.find((input) => input.dataset.fieldName === fieldName)
  }

  preferenceFor(fieldName) {
    return this.preferenceTargets.find((input) => input.dataset.fieldName === fieldName)
  }

  markerFor(targets, fieldName) {
    return targets.find((target) => target.dataset.fieldName === fieldName)
  }

  notifyForm() {
    this.dispatch('changed', { bubbles: true })
  }
}
